import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Util } from '../../../../../utils/util';
import { PixKeyType } from '../../../models/key-type.enum';
import { PixPaymentFavoredView } from '../../../models/payment-favored-view.model';
import { PixPaymentKeyService } from '../../payment-key.service';
import { ModalConfirmService } from '../../../../../shared/modal-confirm/modal-confirm.service';
import { Auth } from '../../../../../autentication/Auth';

@Component({
	selector: 'app-pix-payment-key-favored-create-resume',
	templateUrl: './resume.component.html',
	styleUrls: ['./resume.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixPaymentKeyFavoredCreateResumeComponent implements OnInit {

	public selectedPixPaymentFavoredView: PixPaymentFavoredView;
	pixTax: number;

	constructor(
		private router: Router,
		private pixPaymentKeyService: PixPaymentKeyService,
		private modalConfirmService: ModalConfirmService,
	) {}

	ngOnInit(): void {
		this.selectedPixPaymentFavoredView = this.pixPaymentKeyService.getSelectedPixPaymentFavoredView();
		this.invalidParams() ? this.goBack() : '';
		this.pixTax = this.pixPaymentKeyService.getSelectedPixTax();
	}

	invalidParams(): boolean {
		return this.selectedPixPaymentFavoredView === undefined ||
			this.selectedPixPaymentFavoredView.tipoChave === undefined ||
			(this.selectedPixPaymentFavoredView.tipoChave !== PixKeyType.MANUAL && this.selectedPixPaymentFavoredView.codigo === undefined) ||
			(this.selectedPixPaymentFavoredView.tipoChave === PixKeyType.MANUAL && this.selectedPixPaymentFavoredView.numeroAgencia === undefined || this.selectedPixPaymentFavoredView.numeroConta === undefined)
	}

	get keyType(): typeof PixKeyType {
		return PixKeyType;
	}

	getCpfCnpj(cpfCnpj: string) {
		return Util.maskCpfCnpjPix(cpfCnpj);
	}

	generate = () => this.router.navigate(['pix/pagamento/favorecido/adicionar/assinatura']);
	goBack = () => this.router.navigate(['pix/pagamento/favorecido/adicionar/valor-data']);

	openTaxAlertModal()
	{
		this.modalConfirmService.openAlertModal('Tarifa Pix Pessoa Jurídica', '', 'Esta tarifa está de acordo com seu contrato e com a resolução BCB nº 19/2020. Consulte seu contrato Omni para mais detalhes.', 'Ok', true);
	}

	goToValueDatePage = () => this.router.navigate(['pix/pagamento/favorecido/adicionar/valor-data']);


	get isCnpj(){
		const { cpfCnpj } = Auth.getInstance().getUser();
		const CPF_LENGTH = 11;

		if(cpfCnpj.length === CPF_LENGTH){
			return false;
		}
		
		return true;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/payment-key/favored-create/resume/resume.component.ts